import { render } from "./VisitorPage.vue?vue&type=template&id=84d71aa2&scoped=true"
import script from "./VisitorPage.vue?vue&type=script&lang=js"
export * from "./VisitorPage.vue?vue&type=script&lang=js"

import "./VisitorPage.vue?vue&type=style&index=0&id=84d71aa2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84d71aa2"]])

export default __exports__